<script setup>
  import { computed } from "vue";

  const props = defineProps({
    item: Object,
  });

  const image = computed(() => {
    return {
      'element': props.item.media['element'],
      'imageUrl': props.item.media['image-url'],
      'imageAlt': props.item.media['image-alt']
    }
  })

  const linkItem = computed(() => {
    return props.item.element === 'hero-item-links'
  })
</script>

<template>
  <div
    class="element-hero-item swiper-slide min-h-dvh relative"
  >
    <Media
      :media="image"
    />
    <div
      v-if="linkItem"
      class="element-hero-content w-full flex flex-col items-start justify-center h-[50dvh] lg:h-auto bg-primary lg:bg-transparent ~px-10/24 max-w-screen-2xl lg:absolute lg:w-1/2 lg:top-1/2 right-0"
    >
      <p class="text-white tracking-wider mt-0 mb-4">
        {{ item['small-text'] }}
      </p>
      <div
        class="element-hero-content-links max-w-xl flex flex-col w-full ~mt-6/8"
      >
        <a
          v-for="link, index in item['hero-links']"
          class="element-hero-content-link first:border-t flex flex-row items-center border-b border-white/30 hover:border-b-white cursor-pointer transition-colors text-white px-6 ~py-4/6 ~text-xl/4xl"
          :href="link.href"
        >
          <AppIcon
            name="ArrowLink"
          />
          {{ link.title }}
        </a>
      </div>
    </div>
    <div
      v-else
      class="element-hero-content w-full flex flex-col items-start justify-center h-[50dvh] lg:h-auto bg-primary lg:bg-transparent ~px-10/24 max-w-screen-2xl lg:absolute lg:w-1/2 lg:top-1/2 right-0"
    >
      <p class="text-white tracking-wider mt-0 mb-4">
        {{ item['small-text'] }}
      </p>
      <div
        class="element-hero-content-text"
        v-html="item.text"
      />
      <div
        class="element-hero-content-button ~mt-6/14"
      >
        <a
          class="bg-primary border border-white lg:border-none cursor-pointer text-white px-8 py-4 inline-block rounded-full"
          :href="item.link.href"
        >
          {{ item.link.title }}
        </a>
      </div>
    </div>

  </div>
</template>

<style lang="scss" scoped>
  .element-hero-content-link :deep(span) {
    @apply w-0 opacity-0 overflow-hidden;
    transition: width 0.3s ease-in-out 0.3s, opacity 0.3s ease-in-out;
    svg path {
      fill: #fff !important;
    }
  }
  .element-hero-content-link:hover :deep(span) {
    @apply w-8 opacity-100;
    transition: width 0.3s ease-in-out, opacity 0.3s ease-in-out 0.3s;
  }
  :deep(.media-item) {
    @apply lg:absolute top-0 left-0 w-full h-[50dvh] lg:h-full;
    &::before {
      content: '';
      @apply block absolute top-0 left-0 w-full h-[50dvh] lg:h-full bg-hero/40;
    }
  }

  :deep(.media-item img) {
    @apply w-full h-full object-cover object-top;
  }

  .element-hero-content-text :deep(h2) {
    @apply text-white ~text-2xl/5xl font-normal max-w-screen-md pr-6;
  }
</style>
